<template>
    <div class="fixed z-10 inset-0 overflow-y-auto" role="dialog" @click.stop>
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 opacity-25 bg-gray-500 dark:bg-gray-900 transition-opacity"
                 @click="$emit('closeModal')"></div>
            <div
                class="inline-block z-30 bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-3xl">
                <div class="bg-white dark:bg-gray-800 p-4">
                    <div class="sm:flex sm:items-start" style="max-height: 350px; overflow-y: auto">
                        <div class="mt-3 text-center sm:mt-0 w-full sm:text-left">
                            <div class="flex flex-row items-center mb-4">
                                <UserIcon class="w-6 h-6 mr-3 text-gray-900 dark:text-gray-100"/>
                                <h3 class="text-lg leading-6 text-gray-900 dark:text-gray-100">
                                    Enviar Contato
                                </h3>
                            </div>
                            <div>
                                <p class="text-md ml-2 text-start text-gray-600 dark:text-gray-300 mb-6">
                                    Selecione o contato que você deseja enviar:
                                </p>
                                <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 w-full">
                                    <thead class="bg-gray-50 dark:bg-gray-700">
                                    <tr>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                                            scope="col">
                                            Nome
                                        </th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                                            scope="col">
                                            Telefone
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="contact in contacts" :key="contact.id">
                                        <tr :class="selectedContact.id === contact.id ? 'bg-indigo-100 dark:bg-gray-900 cursor-pointer' : rowClass"
                                            class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
                                            @click="selectContact(contact)">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                                                {{ contact.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-300">
                                                {{ contact.phone_number }}
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 dark:bg-gray-700 px-4 py-6 flex flex-row-reverse gap-4">
                    <button
                        :disabled="selectedContact.id === 0"
                        class="disabled:opacity-25 cursor-pointer disabled:cursor-auto text-sm justify-center rounded-md border shadow-sm px-4 py-3 bg-red-600 text-white hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800"
                        type="button"
                        @click="sendContact"
                    >
                        Enviar Contato
                    </button>
                    <button
                        class="text-sm justify-center cursor-pointer rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-3 bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-500"
                        type="button"
                        @click="$emit('closeModal')"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import {UserIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue"
import VCard from "@src/types/VCard";
import {useVCards} from "@src/composables/useVcards";
import {useChatSessionStore} from "@src/stores/chatSession";
import MessageService from '@src/services/message'


const emit = defineEmits(['closeModal'])
const vCardsComposable = useVCards()
const contacts = vCardsComposable.getVCards()
const sessionStore = useChatSessionStore();
const impair = ref<boolean>(false)

let selectedContact = ref<VCard>({
    id: 0,
    name: '',
    phone_number: '',
    status: '',
})
const selectContact = (contact: VCard) => {
    selectedContact.value = contact
}
const rowClass = () => {
    impair.value = !impair.value
    return impair.value ? ' bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer' : ' bg-gray-50 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 cursor-pointer'
}

const sendContact = async () => {
    sessionStore.openAttachSelector = false

    await MessageService.sendContact(selectedContact.value.id, sessionStore.replyMessage?.id || 0)

    sessionStore.replyMessage = undefined

    selectedContact.value = {
        id: 0,
        name: '',
        phone_number: '',
        status: '',
    }

    sessionStore.scrollDown()
    emit('closeModal')
}
</script>


<style scoped>
</style>